import { useEffect } from "react";

import { useGLTF } from "@react-three/drei";

export function usePortalModelPreload({
  enabled = true,
  currentPortal,
  isMobile,
  rootWarmupModels,
  portalPreloadModels,
  desktopOnlyModels,
}) {
  useEffect(() => {
    if (!enabled) return;

    rootWarmupModels.forEach((path) => useGLTF.preload(path));
  }, [enabled, rootWarmupModels]);

  useEffect(() => {
    if (!enabled) return;

    const models = portalPreloadModels[currentPortal] || [];
    models.forEach((path) => useGLTF.preload(path));

    if (!isMobile && currentPortal === "meet-joz") {
      desktopOnlyModels.forEach((path) => useGLTF.preload(path));
    }
  }, [currentPortal, desktopOnlyModels, enabled, isMobile, portalPreloadModels]);
}
